import React from 'react';
import { Option } from 'types/types';
import SmartLabel, { TSmartLabelProps } from '../labels/SmartLabel';
import MyRadioButton from 'components/controls/MyRadioButton';
import useIsReadOnlyMode from '../compiler/hooks/useIsReadOnlyMode';
import styled from 'styled-components';

type TProps = Partial<TSmartLabelProps> & {
  name: string;
  value: any;
  options: Option[];
  style?: any;
  onChanged: any;
  disabled?: boolean;
  error?: string;
};

const WizardRadioControlledComponent: React.FunctionComponent<TProps> = ({
  label,
  options,
  tooltip,
  labelStyle,
  name,
  value,
  onChanged,
  disabled,
  style,
  required,
  error,
  ...props
}) => {
  const isReadOnly = useIsReadOnlyMode();
  const isDisabled = disabled || isReadOnly;

  return (
    <Container style={style}>
      {label && (
        <SmartLabel
          label={label}
          required={required}
          labelStyle={labelStyle}
          tooltip={tooltip}
          hasValue={!!value}
          error={error}
        />
      )}
      <RadioListContainer>
        {options.map((option) => (
          <RadioItem key={option.value}>
            <MyRadioButton
              inputId={`${name}-${option.value}`}
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={(val) => {
                if (val !== value) {
                  onChanged(name, val);
                }
              }}
              disabled={isDisabled}
            />
            <RadioLabel htmlFor={`${name}-${option.value}`} $disabled={isDisabled}>
              {option.label}
            </RadioLabel>
          </RadioItem>
        ))}
      </RadioListContainer>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const RadioListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const RadioItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const RadioLabel = styled.label<{ $disabled?: boolean }>`
  cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
  user-select: none;
  font-size: 14px;
  color: ${(props) => (props.$disabled ? props.theme.colors.primaryBlack50 : props.theme.colors.primaryBlack)};

  &:hover {
    color: ${(props) => (props.$disabled ? props.theme.colors.primaryBlack50 : props.theme.colors.primaryOrange)};
  }
`;

export default WizardRadioControlledComponent;
